module.exports = __webpack_public_path__ + "img/objetivo_15.e8484bde.webp";